var map = {
	"./fr.json": [
		"./resources/lang/fr.json",
		"resources_lang_fr_json"
	],
	"./it.json": [
		"./resources/lang/it.json",
		"resources_lang_it_json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./resources/lang lazy recursive ^\\.\\/.*\\.json$";
module.exports = webpackAsyncContext;